<template>
  <div>
    <!-- 查询区域 -->
    <el-radio-group
      v-model="table.params.type"
      style="margin-bottom: 10px"
      size="small"
      @change="onSearch"
    >
      <el-radio-button :label="1">需求端</el-radio-button>
      <el-radio-button :label="2">师傅端</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item
          :label="table.params.type == 1 ? '用户名称:' : '师傅名称:'"
          prop="name"
        >
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户账号:" prop="account">
          <el-input
            clearable
            v-model.trim="table.params.account"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付日期:" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="curTableWrap" ref="main">
      <el-table
        :data="table.data"
        ref="tableDom"
        :height="height"
        border
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        :header-cell-style="{ background: '#f5f5f5' }"
        class="chTable"
      >
        <el-table-column label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column
          prop="nickname"
          :label="table.params.type == 1 ? '用户名称' : '师傅名称'"
        >
        </el-table-column>
        <el-table-column prop="account" label="账号"> </el-table-column>
        <el-table-column prop="amount" label="支付金额">
          <template slot-scope="{ row }">
            <span>￥{{ row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transaction_no" label="流水交易号">
        </el-table-column>
        <el-table-column prop="pay_time" label="支付时间"> </el-table-column>
        <el-table-column
          prop="object_name"
          label="查看人员"
          fixed="right"
          width="220"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="showMpDetail(row)">{{
              row.object_name
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <flexpositionDetail ref="flexpositionDetailRef"></flexpositionDetail>
    <recruitDetail ref="recruitDetailRef"></recruitDetail>
  </div>
</template>
<script>
import { mixinTable } from "@/mixins/table.js";
import { calcTableHeight } from "@/util/index.js";
import flexpositionDetail from "@/views/zeroJob/flexposition/components/detailDialog.vue";
import recruitDetail from "@/views/zeroJob/recruit/components/Detail.vue";
export default {
  mixins: [mixinTable],
  components: { flexpositionDetail, recruitDetail },
  data() {
    return {
      height: 0,
      table: {
        loading: false,
        params: {
          type: 1, //1-需求端 2-师傅端
          name: "",
          account: "",
          date: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.calcHeight();
    });
    window.addEventListener("resize", this.resizeHandler);
    this.getTable();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    clearTimeout(this.resizeTimer);
  },
  methods: {
    // resize 防抖，避免高度变化 → 滚动条变化 → resize 的死循环
    resizeHandler() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.calcHeight();
      }, 200);
    },
    // 计算表格最大高度：视口高度 - 表格上方距离 - 下方分页器高度
    calcHeight() {
      this.height = calcTableHeight(this.$refs.main, {
        bottomHeight: 60, // 分页器 + margin
      });
    },
    getTable() {
      let _params = { ...this.table.params };
      this.table.loading = true;
      this.$http
        .get("/admin/flex_trade/amount", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.$nextTick(() => {
              // 	对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              if (this.$refs.tableDom && this.$refs.tableDom.doLayout) {
                this.$refs.tableDom.doLayout();
              }
            });
          }
        });
    },
    showMpDetail(row) {
      if (this.table.params.type == 1) {
        let dom = this.$refs.flexpositionDetailRef;
        dom.toggle(true);
        dom.getDetail({
          ...row,
          id: row.position_id,
        });
      } else {
        let dom = this.$refs.recruitDetailRef;
        dom.toggle(true);
        dom.getDetail({
          ...row,
          id: row.job_id,
        });
        dom = null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.curTableWrap {
  padding: 0 24px;
  background: #fff;
}
.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  padding-right: 40px;
}
</style>
